import React from 'react';
import clsx from 'clsx';

// Material UI
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';

// Hooks
import Styles from './styles';
import { utils } from '../../utils/utils';

const Totals = ({ title, value, color, leftStat, rightStat, rightStatColor, progress }) => {
    const { classes } = Styles();

    return (
        <div className={clsx(classes.card, classes[`border_${color}`])}>
            <Typography className={classes.title}>
                {title}
            </Typography>
            <Typography className={classes.value}>
                {`$${utils.formatMoney(value)}`}
            </Typography>

            <Grid container justifyContent='space-between' className={classes.statRow}>
                <Grid>
                    <Typography className={classes.statText}>
                        {leftStat}
                    </Typography>
                </Grid>
                <Grid>
                    <Typography className={clsx(classes.statText, rightStatColor && classes[`text_${rightStatColor}`])}>
                        {rightStat}
                    </Typography>
                </Grid>
            </Grid>

            {progress &&
                <>
                    <LinearProgress
                        variant='determinate'
                        value={Math.min(Math.max(progress.percent, 0), 100)}
                        className={classes.progress}
                        classes={{ bar: classes[`bar_${color}`] }}
                    />
                    <Typography className={classes.caption}>
                        {progress.caption}
                    </Typography>
                </>
            }
        </div>
    );
}

export default Totals;
